import { IAxiosInstance } from "clients/AbstractApiClient/AbstractApiClient";

export const getContractorPaymentGroupById =
  (axios: IAxiosInstance) => async (groupId: string, q: string) => {
    const response = await axios.noRetry.get(
      `/contractor-payment-group/${groupId}`,
      { params: { q } }
    );
    return response.data.data;
  };
